// @ts-nocheck
export const createEventBus = () => {
  const listeners = new Map();

  const on = (eventName = '', callback = (_payload) => {}) => {
    if (!listeners.has(eventName)) {
      listeners.set(eventName, new Set());
    }

    listeners.get(eventName).add(callback);
    return () => off(eventName, callback);
  };

  const off = (eventName = '', callback = (_payload) => {}) => {
    const eventListeners = listeners.get(eventName);
    if (!eventListeners) return;

    eventListeners.delete(callback);
    if (!eventListeners.size) {
      listeners.delete(eventName);
    }
  };

  const emit = (eventName = '', payload = {}) => {
    const eventListeners = listeners.get(eventName);
    if (!eventListeners) return;

    eventListeners.forEach((callback = (payloadValue) => payloadValue) => callback(payload));
  };

  return {
    on,
    off,
    emit,
  };
};
